import { css } from 'react-emotion';
import { flex } from 'appStyles';

export const container = css`
  position: relative;
  width: 80%;
  box-shadow: 6px 7px 5px -2px #c2baba;
  border: 1px solid #c2baba;   
  padding: 1em; 
`;


export const section = css`
  /* margin: 2rem;  */
`;

export const newSection = css`
  border: 1px solid white;
  cursor: pointer;
  width: 175px;
  padding: 10px;  
`;

export const columns = css`
  display: flex;
  align-items: center;
`;

export const columnOption = css`
  ${flex};
  width: 2.6rem;
  height: 2.6rem;
  border: 1px solid aqua;
  cursor: pointer;
  fontSize: .7rem;
  transition: .2s;

  &:hover {
    background: rgba(200,200,200,.3);
    transition: .3s;
  }

`;

export const imageRow = css`
  margin: 2rem;
  display: flex;
  align-items: center;
`;

export const deleteImage = css`
  display: flex;
  align-items: center;
  color: rgba(200,100,120,1);
  margin-left: 2rem;

  span {
    margin-left: 1rem;
    opacity: 0;
    transition: .2s;
  }

  &:hover {
    span {
      opacity: 1;
      transition: .3s;
    }
  }
`;

export const newImage = css`
  position: relative;
  ${flex};
  width: 6rem;
  height: 3rem;
  border: 1px solid white;
  cursor: pointer;
  margin-left: 4rem;
  border-radius: .2rem;
  transition: .1s;

  &:hover {
    background: rgba(200,200,200,.2);
    transition: .2s;
  }
`;

export const flexRow = css`
  display: flex;
  flex-direction: row;
`;